import React, { useState } from "react";
import { useAuth } from "../context/AuthContext"; // чтобы взять user.id
import { useParams } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";

export const CourseComment = () => {
  const { id: kursId } = useParams(); // id курса из URL
  const { t } = useAppTranslation();
  const { user } = useAuth(); // авторизованный пользователь

  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stars) {
      setMessage(t('pickStars'));
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch("https://api.eduskill.uz/api/comment-kurs/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`, // если требуется авторизация
        },
        body: JSON.stringify({
          stars,
          comment,
          user: user.id,
          kurs: kursId,
        }),
      });

      if (!res.ok) {
        throw new Error(t('commentError'));
      }

      setMessage(t('commentSend'));
      setStars(0);
      setComment("");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const renderStars = () => {
    return [1, 2, 3, 4, 5].map((star) => (
      <span
        key={star}
        style={{
          cursor: "pointer",
          fontSize: "24px",
          color: star <= stars ? "gold" : "#ccc",
        }}
        onClick={() => setStars(star)}
      >
        ★
      </span>
    ));
  };

  return (
    <div className="container about-page">
      <h2>{t('rateTitle')}</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "10px" }}>{renderStars()}</div>
        <textarea
          name="comment"
          placeholder={t('rateComment')}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          style={{ width: "100%", height: "200px", padding: "8px" }}
        />
        <button
          type="submit"
          disabled={loading}
          className="register__btn"
          style={{
            marginTop: "10px",
          }}
        >
          {loading ? t('sending') : t('send')}
        </button>
      </form>
      {message && <p style={{ marginTop: "10px" }}>{message}</p>}
    </div>
  );
};
